var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c(
        "div",
        { class: _vm.$style.header, attrs: { slot: "header" }, slot: "header" },
        [
          _c("i", { staticClass: "material-icons" }, [_vm._v("info_outline")]),
          _c("div", [
            _c("div", { class: _vm.$style.title }, [
              _vm._v(" New User Created "),
            ]),
            _c("div", { class: _vm.$style.subTitle }, [
              _vm._v(" " + _vm._s(_vm.name) + " "),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody",
          class: _vm.$style.body,
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _vm._v(" New user "),
          _c("b", [_vm._v(_vm._s(_vm.name))]),
          _vm._v(
            " was created successfully and given " +
              _vm._s(_vm.role) +
              " privileges. Would you like to send them an invitation so they can complete registration. "
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "button",
            {
              staticClass: "rbButton",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" No, Thank You ")]
          ),
          _c("button", { staticClass: "rbButton mainButton" }, [
            _vm._v(" Yes, Please Send "),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }